import type { HeadingBlock } from '../types/report'
import styles from './blocks.module.css'

export function Heading({ block }: { block: HeadingBlock }) {
  return <h3 className={styles.heading}>{block.text}</h3>
}
